import React, { Component, Fragment } from 'react';
import ConnectedVendorReturnModal from './VendorReturnModal';

export class VendorReturnModalCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleOpenModal(event) {
    event.preventDefault();
    this.setState({ isOpen: true });
  }

  handleCloseModal() {
    this.setState({ isOpen: false });
  }

  render() {
    const { isOpen } = this.state;
    return (
      <Fragment>
        <button
          type="button"
          title="New vendor return"
          id="newVendorReturnButton"
          data-test="create-vendor-return-open-button"
          onClick={this.handleOpenModal}
        >
          <i className="icon-plus green" /> New vendor return
        </button>
        <ConnectedVendorReturnModal
          isCreateMode
          isOpen={isOpen}
          handleCloseModal={this.handleCloseModal}
        />
      </Fragment>
    );
  }
}

export default VendorReturnModalCreate;
